import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import _ from "@lodash";
import { useMemo } from "react";
import GuideListMenu from "./GuideListMenu";
import { useInternationalizedArticles } from "../data/internationalizedArticles";
import { useTranslation } from "react-i18next";

/**
 * The guide categories.
 */
function GuideCategories() {
  const navigate = useNavigate();
  const { t } = useTranslation("helpCenter");
  const { categories, articles } = useInternationalizedArticles();

  const groupedGuides = useMemo(() => {
    return _.map(categories, (category) => ({
      ...category,
      guides: _.filter(articles, { categoryId: category.id }),
    }));
  }, [categories, articles]);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col items-center p-24 sm:p-40 container">
      <div className="flex flex-col w-full max-w-5xl">
        <div className="sm:mt-32">
          <Button
            onClick={handleGoBack}
            color="secondary"
            startIcon={
              <FuseSvgIcon>heroicons-outline:arrow-long-left</FuseSvgIcon>
            }
          >
            {t("BACK_TO_HELP_CENTER")}
          </Button>
        </div>
        <div className="mt-8 text-4xl sm:text-7xl font-extrabold tracking-tight leading-tight">
          {t("GUIDES_AND_RESOURCES")}
        </div>

        {/* Categories Section */}
        <div className="mt-32 sm:mt-48">
          <div className="grid grid-cols-1 sm:grid-cols-2 grid-flow-row gap-y-48 sm:gap-x-52">
            {groupedGuides?.map((category) => (
              <div key={category.id}>
                <div className="mb-16">
                  <Typography
                    // component={Link}
                    // to={`${category.slug}`}
                    className="text-2xl font-semibold"
                    // role="button"
                  >
                    {category.title}
                  </Typography>
                  {category.description && (
                    <Typography color="text.secondary" className="mt-8">
                      {category.description}
                    </Typography>
                  )}
                </div>

                <GuideListMenu
                  list={category.guides}
                  categorySlug={category.slug}
                  maxItems={999}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuideCategories;
